import styled from "styled-components";
import { IThemeProps } from "../../theme";

export const StyledComment = styled.div`
  ${({ theme }: IThemeProps) => `
    .comments-wrap {
      .cmt-form {
        position: relative;
        box-shadow: none;
        border-radius: 32px;
        overflow: hidden;
      }
      .inputBase {
        width: 100%;
        background: ${theme.uptimeColors.grayScales.white};
        border: 1px solid ${theme.uptimeColors.grayScales.gray};
        border-radius: 32px;
        overflow: hidden;
        padding: ${theme.uptimeSpace[8]}px;
        font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`};
      }
      .MuiInputBase-input {
        font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`};
        border-bottom: 0;
        font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      }
      .submit-btn {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: rotate(90deg) translateX(-50%);
        padding: ${theme.uptimeSpace[0]}px;
        &.submit-active-btn {
          .MuiSvgIcon-root {
            color: ${theme.uptimeColors.generalColors.icon.enabled};
          }
        }
      }
    
      .cmt-buttons {
        .MuiButton-root {
          font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`};
          text-transform: unset;
        }
        img, svg {
          width: 20px;
          margin: ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[3]}px ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[0]}px;
          color: ${theme.uptimeColors.generalColors.icon.enabled};
        }
      }
      .buttonLink {
        font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
        line-height: ${theme.uptimeLineHeights.desktop.lh4}px;
      }
      .num-likes {
        display: flex;
        align-items: center;
        img {
          margin: ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[3]}px;
        }
      }
      .comment {
        padding: ${theme.uptimeSpace[7]}px ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[0]}px;
      }
    }
  `}
`;